import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full max-h-[70vh] overflow-y-auto pr-1" }
const _hoisted_2 = {
  key: 0,
  class: "mb-4 rounded-md bg-gray-50 p-4"
}
const _hoisted_3 = { class: "grid grid-cols-2 gap-x-6 gap-y-2 sm:grid-cols-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "Widget", -1)
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "Principal", -1)
const _hoisted_7 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "Reservation", -1)
const _hoisted_9 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "Payment record", -1)
const _hoisted_11 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_12 = { class: "mt-3 flex items-center gap-1.5 border-t border-gray-200 pt-2" }
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 1,
  class: "relative ml-2 border-l border-gray-200"
}
const _hoisted_16 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_17 = { class: "text-xs text-gray-500" }
const _hoisted_18 = {
  key: 0,
  class: "text-xs text-gray-400"
}
const _hoisted_19 = {
  key: 1,
  class: "ml-auto text-xs font-medium text-gray-600"
}
const _hoisted_20 = {
  key: 0,
  class: "mt-1 text-sm text-gray-700"
}
const _hoisted_21 = {
  key: 1,
  class: "mt-0.5 text-xs text-gray-400 break-all"
}
const _hoisted_22 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "relative mt-1 rounded-md bg-gray-100 p-3"
}
const _hoisted_25 = ["title", "onClick"]
const _hoisted_26 = { class: "overflow-x-auto text-xs text-gray-700" }
const _hoisted_27 = {
  key: 2,
  class: "py-6 text-center text-sm text-secondary"
}

import { reactive, ref } from 'vue';

import BaseModal from '@/components/common/BaseModal.vue';
import CopyCheckIcon from './CopyCheckIcon.vue';

import { PaymentGatewayLogsI, TransactionReferenceI } from '@/interfaces/interfaces';
import { statusBadge, typeBadge } from './logBadges';
import { copyText } from './clipboard';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionDetail',
  props: {
    reference: {},
    rows: {}
  },
  emits: ["close"],
  setup(__props: any, { emit }) {





const toggled = reactive<Record<number, boolean>>({});
const copied = ref<string | null>(null);

const dotColor = (statusCode: string): string => {
  switch (statusCode) {
    case 'success':
      return 'bg-green-400';
    case 'failed':
    case 'error':
      return 'bg-red-400';
    case 'cancelled':
      return 'bg-orange-400';
    default:
      return 'bg-gray-300';
  }
};

const prettyPayload = (payload: string): string => {
  try {
    return JSON.stringify(JSON.parse(payload), null, 2);
  } catch {
    return payload;
  }
};

const copy = (text: string, key: string) => {
  copyText(text).then(() => {
    copied.value = key;
    setTimeout(() => {
      if (copied.value === key) {
        copied.value = null;
      }
    }, 1500);
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    title: "Transaction timeline",
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.reference && _ctx.reference.raw)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _hoisted_4,
                  _createElementVNode("p", {
                    class: "text-sm font-medium text-gray-900 truncate",
                    title: _ctx.reference.widgetId
                  }, _toDisplayString(_ctx.reference.widgetId || '-'), 9, _hoisted_5)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_6,
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.reference.principalId || '-'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_8,
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.reference.reservationId || '-'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_10,
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.reference.paymentGatewayId || '-'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", {
                  class: "text-xs text-gray-500 truncate",
                  title: _ctx.reference.raw
                }, _toDisplayString(_ctx.reference.raw), 9, _hoisted_13),
                _createElementVNode("button", {
                  type: "button",
                  class: "shrink-0 text-gray-400 hover:text-primary-main transition-colors",
                  title: copied.value === 'reference' ? 'Copied!' : 'Copy booking reference',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (copy(_ctx.reference.raw, 'reference')))
                }, [
                  _createVNode(CopyCheckIcon, {
                    copied: copied.value === 'reference'
                  }, null, 8, ["copied"])
                ], 8, _hoisted_14)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.rows.length)
          ? (_openBlock(), _createElementBlock("ol", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: row.id,
                  class: "mb-6 ml-5 last:mb-1"
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["absolute -left-[5px] mt-1.5 h-2.5 w-2.5 rounded-full", dotColor(row.statusCode)])
                  }, null, 2),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("time", _hoisted_17, _toDisplayString(row.transactionTimestamp), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium", _unref(typeBadge)(row.type).classes])
                    }, _toDisplayString(_unref(typeBadge)(row.type).label), 3),
                    _createElementVNode("span", {
                      class: _normalizeClass(["inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium", _unref(statusBadge)(row.statusCode).classes])
                    }, _toDisplayString(_unref(statusBadge)(row.statusCode).label), 3),
                    (row.source)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "via " + _toDisplayString(row.source), 1))
                      : _createCommentVNode("", true),
                    (row.amount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(row.amount), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (row.transactionStatus)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(row.transactionStatus), 1))
                    : _createCommentVNode("", true),
                  (row.transactionReferenceId)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(row.transactionReferenceId), 1))
                    : _createCommentVNode("", true),
                  (row.responsePayload)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "text-xs text-action-primary hover:text-primary-dark transition-colors",
                          onClick: ($event: any) => (toggled[row.id] = !toggled[row.id])
                        }, _toDisplayString(toggled[row.id] ? 'Hide payload' : 'Show payload'), 9, _hoisted_23),
                        (toggled[row.id])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "absolute right-2 top-2 text-gray-400 hover:text-primary-main transition-colors",
                                title: copied.value === `payload-${row.id}` ? 'Copied!' : 'Copy payload',
                                onClick: ($event: any) => (copy(prettyPayload(row.responsePayload), `payload-${row.id}`))
                              }, [
                                _createVNode(CopyCheckIcon, {
                                  copied: copied.value === `payload-${row.id}`
                                }, null, 8, ["copied"])
                              ], 8, _hoisted_25),
                              _createElementVNode("pre", _hoisted_26, _toDisplayString(prettyPayload(row.responsePayload)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_27, "No rows found for this transaction."))
      ])
    ]),
    _: 1
  }))
}
}

})